import React from 'react';
import { joinClasses } from '../../../../Utils/className.util';
// @ts-ignore
import styles from './DENTToothEndodonticIcon.module.scss';
import Tooltip from '../../../../Components/Popup/Tooltip';
import Text from '../../../../Components/Base/Text/Text';

interface EndodonticIconData {
	key: string;
	icon: {
		src: string;
		tooltip: string;
	};
}

interface Props {
	iconData: EndodonticIconData[];
	reverse?: boolean;
}

const DENTToothEndodonticIconMultiple = ({ iconData, reverse }: Props) => {
	const firstIcon = iconData[0];

	return (
		<div
			className={joinClasses([styles.wrapper, reverse ? styles.reverse : ''])}>
			<div className={styles.icons}>
				<Tooltip
					position={'top center'}
					trigger={
						<div className={styles.iconWithBadge}>
							<img
								className={styles.icon}
								src={firstIcon.icon.src}
								alt={firstIcon.key}
							/>
							<span className={styles.badge}></span>
						</div>
					}>
					<div className={styles.tooltipIcons}>
						{iconData.map(({ key, icon }) => (
							<Tooltip
								key={key}
								trigger={
									<img
										className={styles.tooltipIcon}
										src={icon.src}
										alt={key}
									/>
								}>
								<Text tx={icon?.tooltip} />
							</Tooltip>
						))}
					</div>
				</Tooltip>
			</div>
		</div>
	);
};

export default DENTToothEndodonticIconMultiple;
